module.exports = __webpack_public_path__ + "img/图片20.e17fbf4b.png";